module.exports = __webpack_public_path__ + "img/home_download_appstore.46492683.png";